var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart__empty"},[_c('h1',[_vm._v("Cart is empty")]),_vm._v(" "),_c('router-link',{staticClass:"button more-info-button",attrs:{"to":"/products"}},[_vm._v("Add Products")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }